import React from 'react';
import { Container, Row } from 'reactstrap';
import IpFrequencyReport from './components/IpFrequencyReport';

export default function FrequencyReportIndex() {
  return (
    <Container className="dashboard">
      <Row>
        <IpFrequencyReport title="AMC IP Frequency Report" />
      </Row>
    </Container>
  );
}
